import { WORKOUT_KEY } from '../../../../../modules/workout/model'
import { WORKOUT_SECTION_KEY } from '../../../model'
import getWorkoutExercisesWorkoutSectionUtil from '../../../model/utils/get-workout-exercises'
import getWorkoutSectionsWorkoutUtil from '../../../../../modules/workout/model/utils/get-workout-sections'
import { getCurrentOrCustomerIdProfileSelect } from '../../../../profile/redux/selectors/get-current-or-customer-id'
import deleteReduxAction from '../../../../redux/actions/delete'
import updateReduxAction from '../../../../redux/actions/update'
import { getIdReduxUtil } from '../../../../redux/utils/get-id'
import { getPathReduxUtil } from '../../../../redux/utils/get-path'
import { getValueReduxUtil } from '../../../../redux/utils/get-value'
import isNewReduxUtil from '../../../../redux/utils/is-new'
import { nextSetStartWorkoutAction } from '../../../../start-workout'
import getCurrentWorkoutSectionIndexStartWorkoutSelect
  from '../../../../start-workout/selectors/get-current-workout-section-index'
import hasStartedStartWorkoutSelect from '../../../../start-workout/selectors/has-started'
import updateCurrentWorkoutSectionAction from '../update-current'
import WORKOUT_SECTIONS_ACTION from '../../constants/action'
import WORKOUT_SECTIONS_ANALYTICS_EVENT from '../../constants/analytics-event'
import { WORKOUT_SECTION_ENDPOINT } from '../../constants/endpoint'
import getByIdWorkoutSectionSelector from '../../selectors/get-by-id'
import getCurrentWorkoutSectionSelect from '../../selectors/get-current'
import updateDataWorkoutAction from '../../../../workout/redux/actions/update-data'
import updateWorkoutSectionsOrderWorkoutAction from '../../../../workout/redux/actions/update-workout-sections-order'
import WORKOUTS_ACTION from '../../../../workout/redux/constants/action'
import getCurrentOrStartedWorkoutSelect from '../../../../workout/redux/selectors/get-current-or-started'
import { logEventAnalyticsUtil } from '../../../../../utils/analytics/log-event'
import { interpolateStringUtil } from '../../../../../utils/string/interpolate'

function updateStartWorkoutSet (workoutSectionPointers) {
  return (dispatch, getState) => {
    if (!hasStartedStartWorkoutSelect(getState())) {
      return
    }
    const currentWorkoutSectionIndex = (
      getCurrentWorkoutSectionIndexStartWorkoutSelect(getState())
    )
    const nextCurWorkoutSectionPointerStartWorkout = (
      workoutSectionPointers[currentWorkoutSectionIndex]
    )
    // If the workout section being deleted is the last one, finish the workout
    if (!nextCurWorkoutSectionPointerStartWorkout) {
      dispatch(nextSetStartWorkoutAction())
      return
    }
    // If the workout section was deleted while the workout was playing
    // and the current workout section is not defined, go to the next one
    const id = (
      getIdReduxUtil(nextCurWorkoutSectionPointerStartWorkout)
    )
    const nextCurWorkoutSectionStartWorkout = (
      getByIdWorkoutSectionSelector(id)
    )(getState())
    if (!nextCurWorkoutSectionStartWorkout ||
      !getWorkoutExercisesWorkoutSectionUtil(nextCurWorkoutSectionStartWorkout).length) {
      dispatch(nextSetStartWorkoutAction())
    }
  }
}

function deleteWorkoutSectionAction () {
  return async (dispatch, getState) => {
    const workoutSection = getCurrentWorkoutSectionSelect(getState())
    // Delete the workout section from the workout
    // and update the workout sections' order
    const workout = getCurrentOrStartedWorkoutSelect(getState())
    let workoutSectionPointers = getWorkoutSectionsWorkoutUtil(workout)
    workoutSectionPointers = workoutSectionPointers.filter(workoutSectionPointer => {
      return (
        getIdReduxUtil(workoutSectionPointer) !== getIdReduxUtil(workoutSection)
      )
    })
    // Delete the workout section from the Workout
    dispatch(updateReduxAction({
      type: WORKOUTS_ACTION.DELETE_WORKOUT_SECTION,
      payload: {
        path: getPathReduxUtil(workout),
        key: WORKOUT_KEY.WORKOUT_SECTIONS,
        value: workoutSectionPointers
      }
    }))
    const order = getValueReduxUtil(workoutSection, WORKOUT_SECTION_KEY.ORDER)
    const newWorkoutSection = workoutSectionPointers[order - 2]
    if (newWorkoutSection) {
      dispatch(updateCurrentWorkoutSectionAction(newWorkoutSection))
    }
    dispatch(updateWorkoutSectionsOrderWorkoutAction(workoutSectionPointers))

    dispatch(updateStartWorkoutSet(workoutSectionPointers))

    // Delete the workout section and its associations
    const payload = {
      path: getPathReduxUtil(workoutSection)
    }

    const canStandaloneSave = (
      !isNewReduxUtil(workoutSection) &&
      getValueReduxUtil(workoutSection, WORKOUT_SECTION_KEY.PROFILE_ID) ===
      getCurrentOrCustomerIdProfileSelect(getState())
    )
    if (canStandaloneSave) {
      payload.endpoint = interpolateStringUtil(WORKOUT_SECTION_ENDPOINT.BY_ID, {
        id: getIdReduxUtil(workoutSection)
      })
    }

    await dispatch(deleteReduxAction({
      type: WORKOUT_SECTIONS_ACTION.DELETE,
      payload
    }))
    // Update the workout's data
    dispatch(updateDataWorkoutAction())
    logEventAnalyticsUtil(WORKOUT_SECTIONS_ANALYTICS_EVENT.DELETED,
      workoutSection
    )
  }
}

export default deleteWorkoutSectionAction
